import React from 'react';
import { useCookieConsent } from '../context/CookieConsentContext';

const CookieBanner: React.FC = () => {
    const { consent, setConsent } = useCookieConsent();

    if (consent !== null) {
        return null;
    }

    return (
        <div className="fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 shadow-lg p-6 z-50">
            <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
                <div className="flex-1 text-gray-800 dark:text-white">
                    <h3 className="font-bold text-lg mb-2">We value your privacy</h3>
                    <p className="text-sm leading-relaxed">
                        We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic.
                        Strictly necessary cookies are always enabled. For more details, please review our Privacy Policy.
                    </p>
                </div>
                <div className="flex flex-col sm:flex-row gap-4 w-full md:w-auto">
                    <button
                        onClick={() => setConsent('denied')}
                        className="flex-1 sm:flex-none px-6 py-2.5 rounded-lg bg-gray-600 text-white font-semibold hover:bg-gray-700 transition-colors shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 dark:bg-gray-700 dark:hover:bg-gray-600"
                    >
                        Reject Non-Essential
                    </button>
                    <button
                        onClick={() => setConsent('granted')}
                        className="flex-1 sm:flex-none px-6 py-2.5 rounded-lg bg-indigo-600 text-white font-semibold hover:bg-indigo-700 transition-colors shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                        Accept All Cookies
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieBanner;
